import React from "react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/material.css";
import { useDispatch, useSelector } from "react-redux";
import { PhoneInputWrapper } from "./PhoneNumberInput.style";
import {
  selectedLocale,
  setCountryCode,
} from "../../store/slices/common/slice";
import { LOCAL_STORAGE_PHONE_COUNTRY } from "../../utils/constants";

const PhoneNumberInput = ({
  phone,
  setPhone,
  placeholder,
  autoFocus,
  defaultCode,
  disabled,
  containerStyle,
}) => {
  const dispatch = useDispatch();
  const countryCode = useSelector((state) => state.commonInfo.countryCode);
  const locale = useSelector(selectedLocale);
  const ar = locale === "ar";
  return (
    <PhoneInputWrapper $ar={ar}>
      <PhoneInput
        searchStyle={{
          borderRadius: 20,
          color: "#484888",
          padding: "5px 10px",
        }}
        inputStyle={containerStyle}
        placeholder={placeholder}
        enableSearch={true}
        defaultCountry={defaultCode || countryCode}
        disableSearchIcon={true}
        countryCodeEditable={false}
        country={"sa"}
        specialLabel={false}
        value={phone}
        onChange={(value, _, e, formattedValue) => {
          if (value === "3810") {
            return;
          }
          setPhone(formattedValue);
        }}
        inputProps={{
          autoFocus: autoFocus,
          disabled: disabled,
          onFocus: () => {},
          onBlur: () => {
            if (phone.startsWith("0")) {
              setPhone(phone.substring(1));
            }
          },
        }}
        countrySelectProps={{
          onBlur: () => {},
          onFocus: () => {},
          onChange: (country) => {
            localStorage.setItem(LOCAL_STORAGE_PHONE_COUNTRY, country.cca2);
            dispatch(setCountryCode(country.cca2));
          },
        }}
        masks={{ rs: ".. ... .. .." }}
      />
    </PhoneInputWrapper>
  );
};

export default PhoneNumberInput;
